function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import './Table.css';

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleWindowKeyDown = function (e) {
      if (e.key === 'Escape') {
        _this.resetSelectedRows();
      } else if (e.key === 'Enter') {
        _this.resetSelectedRows();
      } else if (e.key === 'ArrowDown') {
        _this.handleArrowDownPress();
      } else if (e.key === 'ArrowUp') {
        _this.handleArrowUpPress();
      }

      if (typeof _this.props.onKeyDown === 'function') {
        _this.props.onKeyDown(e, {
          selectedRows: _this.state.selectedRows
        });
      }
    };

    _this.handleSelect = function (row) {
      if (typeof _this.props.onSelect === 'function') {
        _this.props.onSelect({
          row: row
        });
      }
    };

    _this.handleArrowPress = function (step) {
      var lastSelectedElementDataIndex = _this.state.selectedRows[_this.state.selectedRows.length - 1];
      var sortedRecords = _this.reactTable.getResolvedState().sortedData;

      var nextElementDataIndex = -1;

      sortedRecords.forEach(function (record, i) {
        if (record && record._index === lastSelectedElementDataIndex) {
          var next = sortedRecords[i + step];
          if (next) {
            nextElementDataIndex = next._index;
          }
        }
      });

      if (nextElementDataIndex === -1 && sortedRecords[0]) {
        if (step === 1) {
          nextElementDataIndex = sortedRecords[0]._index;
        } else {
          nextElementDataIndex = sortedRecords[sortedRecords.length - 1]._index;
        }
      }

      _this.setState({
        selectedRows: [nextElementDataIndex]
      });

      _this.handleSelect(nextElementDataIndex);
    };

    _this.handleArrowDownPress = function () {
      _this.handleArrowPress(1);
    };

    _this.handleArrowUpPress = function () {
      _this.handleArrowPress(-1);
    };

    _this.handleWindowClick = function (e) {
      _this.resetSelectedRows();
    };

    _this.getTrProps = function (state, rowInfo, column, instance) {
      if (!rowInfo) {
        return {};
      }

      return {
        className: _this.state.selectedRows.includes(rowInfo.index) ? 'Table-table-row-selected' : '',
        onClick: function onClick(e, handleOriginal) {
          e.stopPropagation();

          _this.setState({
            selectedRows: [rowInfo.index]
          });

          var currentRecords = _this.reactTable.getResolvedState().sortedData;

          _this.handleSelect(rowInfo.index);

          if (typeof handleOriginal === 'function') {
            handleOriginal();
          }
        },
        onDoubleClick: function onDoubleClick(e) {
          if (typeof _this.props.onDoubleClick === 'function') {
            _this.props.onDoubleClick({
              row: rowInfo.index
            });
          }
        },
        onContextMenu: function onContextMenu(e) {
          var selectedRows = [rowInfo.index];
          _this.setState({
            selectedRows: selectedRows
          });

          if (typeof _this.props.onContextMenu === 'function') {
            _this.props.onContextMenu({
              selectedRows: selectedRows
            });
          }
        }
      };
    };

    _this.state = {
      selectedRows: []
    };
    return _this;
  }

  Table.prototype.allowKeyboardNavigation = function allowKeyboardNavigation() {
    return !this.props.disableKeyboardNavigation;
  };

  Table.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);

    if (this.allowKeyboardNavigation()) {
      window.addEventListener('keydown', this.handleWindowKeyDown);
    }
  };

  Table.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);

    if (this.allowKeyboardNavigation()) {
      window.removeEventListener('keydown', this.handleWindowKeyDown);
    }
  };

  Table.prototype.resetSelectedRows = function resetSelectedRows() {
    this.setState({
      selectedRows: []
    });

    this.handleSelect(null);
  };

  Table.prototype.getDefaultPageSize = function getDefaultPageSize() {
    if (this.props.defaultPageSize != null) {
      return this.props.defaultPageSize;
    }
    return 14;
  };

  Table.prototype.getPageSize = function getPageSize() {
    if (this.props.pageSize != null) {
      return this.props.pageSize;
    }
    return undefined;
  };

  Table.prototype.showPagination = function showPagination() {
    if (this.props.hidePagination) {
      return false;
    }
    return true;
  };

  Table.prototype.getTheadComponent = function getTheadComponent() {
    if (this.props.hideHeader) {
      return function () {
        return null;
      };
    }
    return undefined;
  };

  Table.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'Table' },
      React.createElement(
        'div',
        { className: 'Table-table' },
        React.createElement(ReactTable, {
          ref: function ref(reactTable) {
            _this2.reactTable = reactTable;
          },
          data: this.props.rows,
          columns: this.props.columns,
          defaultSorted: this.props.sort,
          showPageSizeOptions: false,
          showPagination: this.showPagination(),
          defaultPageSize: this.getDefaultPageSize(),
          pageSize: this.getPageSize(),
          resizable: true,
          getTrProps: this.getTrProps,
          TheadComponent: this.getTheadComponent(),
          manual: this.props.manual,
          onFetchData: this.props.onFetchData,
          pages: this.props.pages
        })
      )
    );
  };

  return Table;
}(Component);

export default Table;